import React from 'react'

function Cred() {
  return (
    <>
      <div className='w-full bg-gray-300 py-5 px-8'>
        <div className='max-w-[1240px] mx-auto text-center divide-y-2 divide-dashed divide-gray-400 space-y-1'>
          <h3 className='text-left text-sm font-medium mx-auto pb-4'>
            <i>Сайт kayrakkum.com основан в 2004 году Евгением Борочиным в память о родителях - Тамаре Бушуевой и Якове Борочине</i>
          </h3>
          <h3 className='text-left text-sm font-medium mx-auto pt-4'>
            <i>Established in 2004 by Eugene Borochin, this website is dedicated to parents Tamara Bushueva and Yakov Borochin</i>
          </h3>
        </div>
      </div>
    </>
  )
}

export default Cred